import SignIn from "../views/Auth/SignIn";
import SignUp from "../views/Auth/SignUp";

let authRoutes = [
  { path: "/login", component: SignIn },
  { path: "/register", component: SignUp },
];

export default authRoutes;
